import React from 'react';
import PropTypes from 'prop-types';
import styles from '../HistoricalDashboardPage/HistoricalDashboardPage.module.scss';
import { HistoricDataGrid } from '../../components/HistoricDataGrid';
import { ATS_TRADE_SYMBOL_SUMMARY, ATS_TRADE_MMID_SUMMARY, ATS_QUOTE_SYMBOL_SUMMARY, ATS_QUOTE_MMID_SUMMARY } from '../../util/dashBoardPageConstants';
import getConfig from '../../config';
const { DASHBOARD_CONFIG } = getConfig();

const ATS_TRADE_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ATS_TRADE_SYMBOL_SUMMARY);
const ATS_TRADE_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ATS_TRADE_MMID_SUMMARY);

const ATS_QUOTE_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ATS_QUOTE_SYMBOL_SUMMARY);
const ATS_QUOTE_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ATS_QUOTE_MMID_SUMMARY);

class HistoricalDashboardAtsGrids extends React.PureComponent {
  render () {
    const historicDateFormat = this.props.historicDateFormat;
    return (
      <div className={styles.atsTables} >
        <HistoricDataGrid
          key={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.identifier}
          identifier={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.identifier}
          header={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.header}
          api={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.historicApi}
          downloadApi={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ATS_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20} />

        <HistoricDataGrid
          key={ATS_TRADE_MMID_SUMMARY_CONFIG.identifier}
          identifier={ATS_TRADE_MMID_SUMMARY_CONFIG.identifier}
          header={ATS_TRADE_MMID_SUMMARY_CONFIG.header}
          api={ATS_TRADE_MMID_SUMMARY_CONFIG.historicApi}
          downloadApi={ATS_TRADE_MMID_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={ATS_TRADE_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ATS_TRADE_MMID_SUMMARY_CONFIG.totalField}
          columns={ATS_TRADE_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ATS_TRADE_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ATS_TRADE_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20} />

        <HistoricDataGrid
          key={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.identifier}
          identifier={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.identifier}
          header={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.historicHeader}
          api={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.historicApi}
          downloadApi={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ATS_QUOTE_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />

        <HistoricDataGrid
          key={ATS_QUOTE_MMID_SUMMARY_CONFIG.identifier}
          identifier={ATS_QUOTE_MMID_SUMMARY_CONFIG.identifier}
          header={ATS_QUOTE_MMID_SUMMARY_CONFIG.historicHeader}
          api={ATS_QUOTE_MMID_SUMMARY_CONFIG.historicApi}
          downloadApi={ATS_QUOTE_MMID_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={ATS_QUOTE_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ATS_QUOTE_MMID_SUMMARY_CONFIG.totalField}
          columns={ATS_QUOTE_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ATS_QUOTE_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ATS_QUOTE_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />
      </div>
    );
  }
}

export default HistoricalDashboardAtsGrids;
export const MemoizedHistoricalDashboardAtsGrids = React.memo(HistoricalDashboardAtsGrids);

HistoricalDashboardAtsGrids.propTypes = {
  historicDateFormat: PropTypes.string
};
